<script>
import Vue from 'vue'
export default {
  template: `<div > <slot/> </div>`
}
</script>
